export function mask(value: string, pattern: string, onlyNum?: boolean) {
  let i = 0;
  let valueLen = value.length;
  const v = value.toString();

  if (onlyNum === true && (value.match(/[a-zA-Z]/g) || []).length) valueLen--;

  let numero = pattern.length - (pattern.match(/#/g) || []).length;
  let newPattern = pattern;
  while (numero > 0) {
    newPattern += "#";
    numero--;
  }
  newPattern = newPattern
    .replace(/#/g, () => {
      if (i <= valueLen && newPattern[i] !== "#") {
        valueLen++;
      }
      return v[i++] || "";
    })
    .slice(0, Math.min(valueLen, pattern.length));

  if (newPattern[newPattern.length - 1] === pattern[newPattern.length - 1])
    return newPattern.slice(0, newPattern.length - 1);
  else return newPattern;
}

export function unMask(value: string, pattern: string) {
  const j = new RegExp(pattern);
  const newValue = value.split(j);
  const newString = newValue.join("");

  return newString;
}

export function currencyFormat(num: number, decimal = false) {
  let str = num
    .toLocaleString("pt-BR")
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");

  if (decimal) {
    if (str[str.length - 2] === ",") str = str + "0";
    if (str[str.length - 3] !== ",") str = str + ",00";
  }

  return str;
}

export function cpfMask(value: string) {
  return value
    .replace(/\D/g, "") // substitui qualquer caracter que nao seja numero por nada
    .replace(/(\d{3})(\d)/, "$1.$2") // captura 2 grupos de numero o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d{1,2})/, "$1-$2")
    .replace(/(-\d{2})\d+?$/, "$1"); // captura 2 numeros seguidos de um traço e não deixa ser digitado mais nada
}

export function cnpjMask(value: string) {
  const clean = value
    .replace(/[^0-9A-Za-z]/g, "")
    .toUpperCase()
    .slice(0, 14);
  return clean
    .replace(/^([A-Z0-9]{2})([A-Z0-9])/, "$1.$2")
    .replace(/^([A-Z0-9]{2})\.([A-Z0-9]{3})([A-Z0-9])/, "$1.$2.$3")
    .replace(/\.([A-Z0-9]{3})([A-Z0-9])/, ".$1/$2")
    .replace(/([A-Z0-9]{4})([A-Z0-9])/, "$1-$2");
}

export function numberMask(value: string) {
  return value.replace(/\D/g, ""); // substitui qualquer caracter que nao seja numero por nada
}

// Máscara dinâmica de CPF/CNPJ: aceita alfanumérico desde o primeiro caractere
// (sem o deadlock do react-input-mask). CNPJ quando houver letra ou > 11 chars,
// senão CPF. Usado pelo CpfCnpjMaskedInput.
export function cpfCnpjMask(value: string) {
  const clean = String(value || "")
    .replace(/[^0-9A-Za-z]/g, "")
    .toUpperCase()
    .slice(0, 14);
  const hasLetter = /[A-Z]/.test(clean);
  return !hasLetter && clean.length <= 11 ? cpfMask(clean) : cnpjMask(clean);
}
